import { render } from "./dcautocomplete.vue?vue&type=template&id=448b878f&ts=true"
import script from "./dcautocomplete.vue?vue&type=script&lang=ts"
export * from "./dcautocomplete.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__